exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".km-select .Select-control {\n  color: #333;\n  background-color: #F9F9F9;\n  width: 315px; }\n\n.Select-menu {\n  width: 314px !important; }\n\n.Select-option {\n  width: 313px !important; }\n\n.Select-menu-outer {\n  width: 315px !important;\n  border-right: solid #ccc 1px !important; }\n\n.Select .is-focused {\n  color: #333;\n  border-color: none;\n  background-color: #F9F9F9; }\n\n.user-select .Select-value {\n  margin-top: 7px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/selector.sass
// module id = 1442
// module chunks = 0